import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7656d7e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "anmly-graph-tooltip-info-date"
}
const _hoisted_2 = { class: "anomaly-graph-tooltip-info" }
const _hoisted_3 = {
  key: 1,
  class: "anmly-selected-info-box"
}
const _hoisted_4 = { class: "anmly-selected-info-title" }
const _hoisted_5 = { class: "anmly-selected-info-sub-text" }
const _hoisted_6 = { class: "anmly-selected-info-text" }

import { computed } from 'vue';
import RexStatisticV3 from '@/rex-components/RexStatisticV3.vue';
import RexTagV3 from '@/rex-components/RexTagV3.vue';
import {
  graphTooltipInfoConfig,
  anomalyInfoObject,
  anomalyTypeColorMapper,
  severityTypeMapper,
  severityKeyMapper,
  anomalyTagTextColor,
} from '@/components/charts/utils/utils.config';
import { GraphTooltipKeysType } from '@/components/charts/utils/utils.types';
import {
  AnomalyDataObjectType,
  GraphDataNamesEnum,
} from '@/components/Common/graph.types';
import { formatDate } from '@/utils/time/formatDate';
import { useI18n } from 'vue-i18n';
import { RexConfigProvider } from '@/rex-components/rex.comp.config';

interface Props {
  tooltipInfoData: GraphTooltipKeysType;
  anomalyInfo?: AnomalyDataObjectType;
  isAnomalySelected?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AnomalyGraphFooter',
  props: {
    tooltipInfoData: {},
    anomalyInfo: { default: () => anomalyInfoObject },
    isAnomalySelected: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();

function getFormattedData(key) {
  return props.tooltipInfoData[key] ?? 'NA';
}

const getTagText = computed(
  () => severityTypeMapper[props.anomalyInfo[GraphDataNamesEnum.SEVERITY]],
);
const getAnomalyKey = computed(
  () => severityKeyMapper[props.anomalyInfo[GraphDataNamesEnum.SEVERITY]],
);
const getTagColor = computed(() => anomalyTypeColorMapper[getAnomalyKey.value]);
const getTagTextColor = computed(
  () => anomalyTagTextColor[getAnomalyKey.value],
);

const roundValues = (val) => Math.round(val * 1000) / 1000;
const getSelectedAnomalyFooterInfo = computed(() => {
  const upperThreshold = Number(
    props.anomalyInfo[GraphDataNamesEnum.UPPER_THRESHOLD],
  );
  const lowerThreshold = Number(
    props.anomalyInfo[GraphDataNamesEnum.LOWER_THRESHOLD],
  );
  const groundTruth = props.anomalyInfo.y || 0;

  return upperThreshold < groundTruth
    ? t('metricIncreasedBreachingUpperThreshold', [
        roundValues(groundTruth),
        roundValues(upperThreshold),
      ])
    : t('metricDecreasedBreachingLowerThreshold', [
        roundValues(groundTruth),
        roundValues(lowerThreshold),
      ]);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.tooltipInfoData.time)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(formatDate)(
          new Date(props.tooltipInfoData.time).getTime(),
          0,
          'YYYY-MM-DD HH:mm A',
        )), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(graphTooltipInfoConfig), (obj, i) => {
        return (_openBlock(), _createBlock(RexStatisticV3, {
          value: getFormattedData(obj.key),
          title: obj.label,
          key: `${obj.key}-${i}`,
          class: "anmly-graph-footer-statistic"
        }, null, 8, ["value", "title"]))
      }), 128))
    ]),
    (_ctx.isAnomalySelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(RexConfigProvider), {
              theme: {
            components: {
              Tag: {
                colorTextLightSolid: getTagTextColor.value,
              },
            },
          }
            }, {
              default: _withCtx(() => [
                _createVNode(RexTagV3, {
                  color: getTagColor.value,
                  class: "anmly-selected-info-tag-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTagText.value), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["theme"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatDate)(
              new Date(_ctx.anomalyInfo.x).getTime(),
              0,
              'YYYY-MM-DD HH:mm A',
            )), 1)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(getSelectedAnomalyFooterInfo.value), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})